import {paginatedListAction} from '@/vuex/paginatedListAction';
import mutations from './mutations';


const state = () => ({
    listQuery: {},
    trails: [],
    count: 0,
    currentPage: 1,
    pageSize: 20,
    filters: {
        page: 1,
        pageSize: state.pageSize,
    },
    filesCount: 0,
    filesCurrentPage: 1,
});

const actions = {
    /**
     *
     * Get trails (depending on acl)
     *
     * @param commit
     * @returns {Promise<void>}
     */
    getTrails: paginatedListAction({endpoint: '/audits', prefix: 'trailsData'}),
    /**
     *
     * @param commit
     * @param page
     * @returns {Promise<void>}
     */
    async setCurrentPageTrail({commit}, page) {
        await commit('setCurrentPageTrail', page);
    },
};

export default {
    namespaced: false,
    state,
    actions,
    mutations,
};
